const common = {
	getDateNow(fmt){
		var date = new Date()
		var o = { 
			"M+" : date.getMonth()+1,                 //月份 
			"d+" : date.getDate(),                    //日 
			"h+" : date.getHours(),                   //小时 
			"m+" : date.getMinutes(),                 //分 
			"s+" : date.getSeconds(),                 //秒 
			"q+" : Math.floor((date.getMonth()+3)/3), //季度 
			"S" : date.getMilliseconds()             //毫秒 
		}; 
		if(/(y+)/.test(fmt)) {
			fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
		}
		for(var k in o) {
			if(new RegExp("("+ k +")").test(fmt)){
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
			}
		}
		return fmt; 
	},
	getDateFormat(date,fmt){
		var o = {
			"M+" : date.getMonth()+1,                 //月份 
			"d+" : date.getDate(),                    //日 
			"h+" : date.getHours(),                   //小时 
			"m+" : date.getMinutes(),                 //分 
			"s+" : date.getSeconds(),                 //秒 
			"q+" : Math.floor((date.getMonth()+3)/3), //季度 
			"S" : date.getMilliseconds()             //毫秒 
		}; 
		if(/(y+)/.test(fmt)) {
			fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
		}
		for(var k in o) {
			if(new RegExp("("+ k +")").test(fmt)){
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
			}
		}
		return fmt; 
	},
	filterCount(playCount){
		if(playCount<9999){
			return playCount.toFixed(2)+'万'
		}else{
			return (playCount/10000).toFixed(2)+'亿'
		}
	},
	getLabelByValue(list, targetValue, valueKey = 'value', labelKey = 'label', childrenKey = 'children') {
	  // 边界条件处理：如果列表为空或目标值为空，直接返回 null
	  if (!list || !Array.isArray(list) || list.length === 0 || targetValue === null || targetValue === undefined) {
	    return null;
	  }
	
	  for (let i = 0; i < list.length; i++) {
	    const item = list[i];
	    
	    // 1. 如果当前项的 value 匹配，直接返回 label
	    if (item[valueKey] === targetValue) {
	      return item[labelKey];
	    }
	    
	    // 2. 如果当前项有子级（children），且子级是数组，则递归查找
	    if (item[childrenKey] && Array.isArray(item[childrenKey])) {
	      const foundLabel = getLabelByValue(item[childrenKey], targetValue, valueKey, labelKey, childrenKey);
	      if (foundLabel !== null) {
	        return foundLabel;
	      }
	    }
	  }
	
	  // 3. 遍历完所有项都没找到，返回 null
	  return null;
	}
	
}
export default common